import { AxiosInstance } from "axios";

export const reportViolation = async (
    authenticatedAxios: AxiosInstance,
    reportingEntity: string,
    violatingEntity: string,
    violationType: string,
    message: string
) => {
    try {
        const response = await authenticatedAxios
            .post("/violations", {
                reportingEntity,
                violatingEntity,
                violationType,
                message,
            });

        return response.data;
    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : "Failed to report violation"
        };
    }
}; 